import axios from 'axios';
import { DocumentType } from '../types/documentType';
import config from '../config';
import DataDogInstance from '../utils/monitoring';
import { RateLimiter } from '@utils/rateLimit';

const gatewayUrl = config.APIGW_URL;

export async function getDocumentUrl(
  documentType: DocumentType
): Promise<string> {
  try {
    await RateLimiter.getInstance().checkRateLimit('documentUrl');
    const response = await axios.get(`${gatewayUrl}/document/getUrl`, {
      params: { documentType },
      headers: {
        'X-CG-AppIdentifier': 'coign-web',
      },
    });

    return response.data.data.url;
  } catch (error) {
    DataDogInstance.getInstance().logError('Error fetching document URL', {
      documentType,
    });
    throw error;
  }
}
